import React, { Fragment, useState, useEffect } from "react";
import SelectReact from "react-select";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Select(props) {
  const { form, field } = props;

  const optionsWithNone = [
    { value: null, label: "هیچ‌کدام" },
    ...(props.options || []),
  ];

  useEffect(() => {
    if (field.value != undefined && optionsWithNone) {
      setSelected(
        optionsWithNone.filter((item) => item.value == field.value)[0]
      );
    }
  }, [props.options, field.value]);

  const [selected, setSelected] = useState(null);

  const onChangeHandler = (item) => {
    if (!item) {
      form.setFieldValue(field.name, null);
      setSelected(null);
      if (props.alsoOnchange) {
        props.alsoOnchange(null);
      }
      return;
    }
    form.setFieldValue(field.name, item.value);
    setSelected(item);
    if (props.alsoOnchange) {
      props.alsoOnchange(item.value);
    }
  };

  return (
    <div
      className="text-sx col-span-2 mt-3"
      style={{ zIndex: 99, position: "relative" }}
    >
      <label
        className="block uppercase text-blueGray-600 dark:text-gray-300 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact
        className="hashure-select-container"
        classNamePrefix="hashure-select"
        placeholder="انتخاب..."
        value={optionsWithNone.find(
          (option) => option.value === selected?.value
        )}
        onChange={onChangeHandler}
        options={optionsWithNone}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 999999999999999999 }),
        }}
        isClearable={true}
      />
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
}
